function l(e) {
  return e === null || typeof e != "object" ? {} : Object.keys(e).reduce((n, u) => {
    const t = e[u];
    return t != null && t !== !1 && (n[u] = t), n;
  }, {});
}
export {
  l as filterErrors
};
